// import React, { useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const SecTeamMemberDetails = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [member, setMember] = useState(location.state?.member || null);

//   useEffect(() => {
//     if (!location.state?.member) {
//       // Set fake data as fallback
//       setMember({
//         name: 'Amol Acharya',
//         qualifications: 'MIE, CEng',
//         position: 'Principal / Structures',
//         image: require('../Images/employeimges copy/AFF_8961 copy.jpg'), // Change path as needed
//         contact: '888‑883‑5108',
//         office: 'Pune, Bengaluru',
//         expertise: [
//           'Seismic Analysis & Design',
//           'High Rise Building',
//           'Steel Structures',
//           'Reinforced Concrete Structures',
//         ],
//         about: 'Amol is a highly experienced structural engineer with 24+ years in delivering projects across India, UAE, UK, USA.',
//         education: 'B.E., Civil Engineering, Nagpur University; M.Tech., Structural Engineering, VNIT Nagpur',
//         publications: 'Optimization Techniques for Precast Construction Industry, Roof Design of Narendra Modi Stadium',
//       });
//     }
//   }, [location.state]);

//   if (!member) {
//     return <div style={styles.error}>Loading member profile...</div>;
//   }

//   const { name, position, about, expertise, education, publications, office, contact } = member;

//   return (
//     <div style={styles.container}>
//       <button style={styles.backButton} onClick={() => navigate(-1)}>← Back</button>

//       <div style={styles.content}>
//         <img src={member.image} alt={name} style={styles.photo} />
//         <h1 style={styles.name}>{name}</h1>
//         {member.qualifications && (
//           <p style={styles.qual}>{member.qualifications}</p>
//         )}
//         {contact && <p style={styles.contact}>{contact}</p>}
//         {office && <p style={styles.office}>Office: {office}</p>}

//         {expertise?.length > 0 && (
//           <>
//             <h3 style={styles.sectionTitle}>Areas of Expertise</h3>
//             <ul style={styles.list}>
//               {expertise.map((item, idx) => <li key={idx}>{item}</li>)}
//             </ul>
//           </>
//         )}

//         {about && (
//           <>
//             <h3 style={styles.sectionTitle}>About / Practice Areas</h3>
//             <p style={styles.text}>{about}</p>
//           </>
//         )}

//         {education && (
//           <>
//             <h3 style={styles.sectionTitle}>Education</h3>
//             <p style={styles.text}>{education}</p>
//           </>
//         )}

//         {publications && (
//           <>
//             <h3 style={styles.sectionTitle}>Publications</h3>
//             <p style={styles.text}>{publications}</p>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     padding: '2rem',
//     maxWidth: '800px',
//     margin: 'auto',
//     fontFamily: 'Segoe UI, sans-serif',
//   },
//   backButton: {
//     marginBottom: '1rem',
//     background: 'none',
//     border: 'none',
//     color: '#0077cc',
//     cursor: 'pointer',
//     fontSize: '1rem',
//     textDecoration: 'underline',
//   },
//   content: {
//     textAlign: 'center',
//   },
//   photo: {
//     width: '200px',
//     height: '200px',
//     objectFit: 'contain',
//     borderRadius: '100px',
//     marginBottom: '1.2rem',
//   },
//   name: {
//     fontSize: '2rem',
//     fontWeight: '700',
//     margin: 0,
//   },
//   qual: {
//     fontStyle: 'italic',
//     color: '#555',
//     marginTop: '4px',
//   },
//   contact: {
//     marginTop: '6px',
//     fontSize: '0.95rem',
//     color: '#0077cc',
//   },
//   office: {
//     marginTop: '4px',
//     fontSize: '0.95rem',
//     color: '#666',
//   },
//   sectionTitle: {
//     fontSize: '1.3rem',
//     marginTop: '2rem',
//     marginBottom: '0.5rem',
//     textAlign: 'left',
//   },
//   list: {
//     listStyleType: 'disc',
//     margin: '0 auto',
//     paddingLeft: '1.2rem',
//     maxWidth: '600px',
//     textAlign: 'left',
//     color: '#333',
//   },
//   text: {
//     maxWidth: '650px',
//     margin: '0.5rem auto',
//     textAlign: 'left',
//     color: '#444',
//     lineHeight: 1.5,
//   },
//   error: {
//     padding: '2rem',
//     textAlign: 'center',
//     color: '#333',
//   },
// };

// export default SecTeamMemberDetails;



import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaEnvelope, FaFacebook, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { color } from 'framer-motion';
import BackBtn from '../Components/BackBtn';
import { AppConstant } from '../AppConstant';

const SecTeamMemberDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    // useEffect(() => {
    //     window.scrollTo(0, 0); // scroll to top on component mount
    // }, [location]);
    // const member = location.state?.member;
    const member = location.state?.member || location.state?.director;

    const width = window.innerWidth;

    if (!member) {
        return <div style={styles.error}>No team member data provided.</div>;
    }


    const {
        name,
        qualifications,
        position,
        about,
        expertise,
        education,
        publications,
        contact,
        email,
        services,
        markets,
        offices
    } = member;

    return (
        <div style={styles.container}>


            <div style={styles.imageContainer}>
                <BackBtn fixed={true} />
                <h1 style={styles.headerName}>{name}</h1>

                <img src={member.cover} alt="Foreground" style={styles.imagepgoto} />
            </div>


            <div style={styles.headerBar}>
                <div style={styles.headerLeft}>

                    {qualifications && <p style={styles.qual}>{qualifications}</p>}
                    {position && <p style={styles.position}>{position}</p>}
                </div>
                <div style={styles.contactBlock}>
                    {contact && <p style={styles.contact}>{contact}</p>}
                    {email && (
                        <p style={styles.email}>
                            <FaEnvelope style={{ marginRight: '8px', verticalAlign: 'middle', color: '#ffffff', }} />
                            {email}
                        </p>
                    )}


                </div>

            </div>


            <div style={styles.content}>


                {about && (
                    <>
                        <h3 style={styles.sectionTitle}>About</h3>
                        <p style={styles.text}>{about}</p>
                    </>
                )}

                {expertise?.length > 0 && (
                    <>
                        <h3 style={styles.sectionTitle}>Areas of Expertise</h3>
                        <ul style={styles.list}>
                            {expertise.map((item, idx) => <li key={idx}>{item}</li>)}
                        </ul>

                    </>
                )}

                {education && (
                    <>
                        <h3 style={styles.sectionTitle}>Education</h3>

                        <ul style={styles.list}>
                            {education.map((item, idx) => <li key={idx}>{item}</li>)}
                        </ul>

                    </>
                )}

                {publications && (
                    <>
                        <h3 style={styles.sectionTitle}>Publications</h3>
                        <p style={styles.text}>{publications}</p>
                    </>
                )}

                {offices && (
                    <>
                        <h3 style={styles.sectionTitle}>Office</h3>
                        <p style={styles.text}>{offices}</p>
                    </>
                )}

                {services && (
                    <>
                        <h3 style={styles.sectionTitle}>Services</h3>
                        <p style={styles.text}>{services}</p>
                    </>
                )}

                {markets && (
                    <>
                        <h3 style={styles.sectionTitle}>Markets</h3>
                        <p style={styles.text}>{markets}</p>
                    </>
                )}
            </div>

        </div>
    );
};

const styles = {
    container: {
        fontFamily: 'Segoe UI, sans-serif',
        color: '#222',
        backgroundColor: 'white',
        // backgroundImage: 'url("https://www.transparenttextures.com/patterns/graphy.png")',
        // minHeight: '100vh',

    },
    email: {
        marginTop: '6px',
        fontSize: '0.95rem',
        fontWeight: 500,
        color: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    headerBar: {

        width: '95%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 4%',
        backgroundColor: '#0A1733', // fallback color
        backgroundImage: 'url("https://www.transparenttextures.com/patterns/cubes.png")',
        color: '#fff',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    headerLeft: {
        maxWidth: '60%',
    },

    position: {
        fontSize: '1.2rem',
        fontWeight: 500,
        color: '#ffffff'
    },
    qual: {
        fontStyle: 'italic',
        fontSize: '1rem',
        fontWeight: 400,
        color: '#ffffff',
        marginBottom: '0.5rem',
    },
    contactBlock: {
        textAlign: 'right',
        alignSelf: 'center',
    },
    contact: {
        fontSize: '1rem',
        marginBottom: '4px',
    },
    // email: {
    //     fontSize: '0.95rem',
    //     color: '#ccc',
    // },
    content: {
        maxWidth: '1000px',
        margin: 'auto',
        padding: '3rem 1.5rem',
        
    },
    imageWrapper: {
        textAlign: 'center',
        // marginBottom: '2rem',
        background: 'linear-gradient(90deg, #8c52ff, #5cele6)',   // optional, remove border

    },
    photo: {
        width: '100%',
        height: '800px',        // or any height you prefer
        objectFit: 'cover',
        borderRadius: '0',      // no round edges
        border: 'none',
        // background: 'linear-gradient(90deg, #8c52ff, #5cele6)',   // optional, remove border
    },
    imageContainer: {
        // background: 'linear-gradient(90deg, #8c52ff, #5ce1e6)',
        backgroundColor: '#e9eef3',
        width: '98%',
        height: '400px', // adjust as needed
        display: 'flex',
        justifyContent: 'flex-end', // changed from 'center' to 'flex-end'
        alignItems: 'center',
        position: 'relative',
        paddingRight: '5%',
    },
    imagepgoto: {
        maxWidth: '100%',
        height: '100%',
        objectFit: 'contain',
    },
    headerName: {
        fontSize: '4.5rem',
        fontWeight: 900,
        marginBottom: '0.3rem',
        letterSpacing: '2px',
        color: '#222222',
        // color:"white",
        textTransform: 'uppercase',
        letterSpacing: '2px',

        // Typing effect


    },





    sectionTitle: {
        fontSize: '1.5rem',
        marginTop: '2rem',
        marginBottom: '0.5rem',
        borderBottom: '2px solid #002D62',
        paddingBottom: '5px',
        color: '#002D62',
    },
    list: {
        listStyleType: 'disc',
        paddingLeft: '1.5rem',
        color: '#0A1733',
        fontWeight: '600',
    },
    text: {
        lineHeight: 1.6,
        color: '#0A1733',
        // textTransform: "capitalize",
        fontWeight: '600',
    },
    error: {
        padding: '2rem',
        textAlign: 'center',
        color: '#333',
    },
};

// Mobile-specific adjustments using media query
const mobileStyles = `
@media (max-width: 768px) {
  .imageContainer {
    flex-direction: column;  // stack vertically
    height: 250px;
  }
  .headerName {
    font-size: 2.2rem;
    max-width: 90%;
    text-align: center;
  }
  .imagepgoto {
    max-width: 100%;
    height: auto;
  }
}
`;

export default SecTeamMemberDetails;
